import { QueryClient } from "@tanstack/react-query";

interface ParamSet {
 name: string;
 // eslint-disable-next-line @typescript-eslint/no-explicit-any
 value: any;
}

interface ParamsBuilderProps {
 sets: ParamSet[];
}

export const buildParams = (params: ParamsBuilderProps) => {
 const strings = params.sets.map((s) => {
   return s.value !== undefined ? `${s.name}=${s.value}` : '';
 });
 return strings.join('&');
};

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			// Default query options
			retry: 2, // Number of retries
			retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff
			refetchOnWindowFocus: false,
		},
		mutations: {
			// Default mutation options
		},
	},
});